import React from "react";
import { t } from "ttag";

import { PricingDisclaimerText } from "../../../common/PricingDisclaimer";
import { IPostDiscountAddons } from "../../../models/prices";
import { format } from "../../../utils/format";
import { Dinero, getDinero } from "../../../utils/money";

import styles from "./common.module.scss";

export const LinePrice = (
    props: React.PropsWithChildren<{
        retailPrice: Dinero;
        linePriceInclDiscounts: Dinero;
        postDiscountAddons: IPostDiscountAddons | undefined;
        quantity: number;
        lastFullPriceDate?: Date | null;
    }>,
): React.ReactNode => {
    if (props.retailPrice.equalsTo(props.linePriceInclDiscounts)) {
        return (
            <div className={styles.priceRegular}>
                {format.money(props.linePriceInclDiscounts)}
            </div>
        );
    }
    const postDiscountAddons = props.postDiscountAddons || [];
    return (
        <>
            <span className="ada-screenreader-only">{t`Original price:`}</span>
            <div
                className={
                    props.retailPrice.greaterThan(props.linePriceInclDiscounts)
                        ? styles.priceStrikeThru
                        : styles.priceRegular
                }
            >
                {format.money(props.retailPrice)}
            </div>
            {props.children}
            {postDiscountAddons.map((addon, i) => (
                <div key={i} className={styles.pricePostDiscountAddon}>
                    <span>{addon.name}</span>
                    <span>
                        {/* TODO(i18n): Don't hardcode "+" symbol - some locales may use different formatting for additions (e.g., Arabic uses ‎+‎ with different spacing) */}
                        {"+"}
                        {format.money(
                            getDinero(addon.price_excl_tax).multiply(
                                props.quantity,
                            ),
                        )}
                    </span>
                </div>
            ))}
            <span className="ada-screenreader-only">{t`Current price:`}</span>
            <div
                className={
                    props.retailPrice.greaterThan(props.linePriceInclDiscounts)
                        ? styles.price
                        : styles.priceRegular
                }
            >
                {format.money(props.linePriceInclDiscounts)}
                {props.lastFullPriceDate && (
                    <PricingDisclaimerText
                        lastFullPriceDate={props.lastFullPriceDate}
                    />
                )}
            </div>
        </>
    );
};
